// extracted by mini-css-extract-plugin
export default {"mobile":"mobile_mobile__Sj9Ab","rotate":"mobile_rotate__EuekT"};